<template>
    <div class="error404">
        <h1>Finner ikke siden(404)</h1>
        <p>Det kan skyldes at siden er flyttet, har fått ny adresse eller ikke finnes.</p>
        <p>Du kan forsøke å finne siden ved å:</p>
        <ul>
            <li>Gå til <router-link to="/">forsiden</router-link>.</li>
            <li>Prøve å skrive inn adressen på ny.</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'Error404',
};
</script>
<style lang="scss">
@import '@/styles/global';

.error404 {
    padding: 30px;

    @include bp($laptop) {
        padding-top: 60px;
        padding-bottom: 60px;
    }
}
</style>
